(function () {
  const TRANSITION_MS = 600;
  const accordions = document.querySelectorAll(".accordion");
  if (!accordions.length) return;

  accordions.forEach((accordion) => {
    const items = accordion.querySelectorAll(".accordion__item");

    items.forEach((item) => {
      const trigger = item.querySelector(".accordion__trigger");
      const panel = item.querySelector(".accordion__panel");
      if (!trigger || !panel) return;

      trigger.addEventListener("click", () => {
        const isExpanded = item.classList.contains("accordion__item--expanded");

        if (isExpanded) {
          item.classList.remove("accordion__item--expanded");
          trigger.setAttribute("aria-expanded", "false");

          setTimeout(() => {
            panel.hidden = true;
          }, TRANSITION_MS);
        } else {
          panel.hidden = false;

          requestAnimationFrame(() => {
            item.classList.add("accordion__item--expanded");
          });

          trigger.setAttribute("aria-expanded", "true");

          items.forEach((inactiveItem) => {
            if (inactiveItem !== item) {
              inactiveItem.classList.remove("accordion__item--expanded");
              inactiveItem
                .querySelector(".accordion__trigger")
                .setAttribute("aria-expanded", "false");
            }
          });
        }
      });
    });
  });
})();
